import { Work, WorkSearch } from "@models/work";
import { buildWorkSort, WorkSort, WORK_BROWSE_PER_PAGE } from "@features/tickets/api/worksBrowse.utils";
import { useSearchWorksBrowseQuery } from "@features/tickets/api/works.api";
import { useResourceBrowse } from "@features/tickets/shared/hooks/useResourceBrowse";
import { parseWorksUrlParams, syncWorksUrlParams } from "./worksUrlParams";

export function useWorksBrowse() {
  const browse = useResourceBrowse<WorkSearch, Work, WorkSort>({
    parseBrowseUrlParams: parseWorksUrlParams,
    syncBrowseUrlParams: syncWorksUrlParams,
    buildSort: buildWorkSort,
    useBrowseQuery: useSearchWorksBrowseQuery,
    defaultPerPage: WORK_BROWSE_PER_PAGE,
  });

  return {
    workSearchForm: browse.form,
    data: browse.data,
    isLoading: browse.isLoading,
    sortKey: browse.sortKey,
    sortMethod: browse.sortMethod,
    handleSortKeyChanged: browse.handleSortKeyChanged,
    handleSortMethodChanged: browse.handleSortMethodChanged,
    page: browse.page,
    perPage: browse.perPage,
    hasNextPage: browse.hasNextPage,
    hasPrevPage: browse.hasPrevPage,
    handleNextPage: browse.handleNextPage,
    handlePrevPage: browse.handlePrevPage,
    handleRowsPerPageChange: browse.handleRowsPerPageChange,
    reset: browse.reset,
  };
}
